import React from 'react';
import { HistoryIcon } from 'lucide-react';
export function DatabaseReactivation() {
  return <section id="database" aria-labelledby="database-title" className="border-b border-white/5 bg-ink-900" data-id="element-44" data-mp="24lmysmh17d6i">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-45" data-mp="1zls92m8zstn1">
        <div className="max-w-3xl" data-id="element-46" data-mp="1uorx5upgowo0">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-brand/30 bg-brand/10" data-id="element-47" data-mp="1unqnnuo3gi8e">
            <HistoryIcon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-48" data-mp="1pqqhzkv5phht" />
          </span>
          <p className="mt-6 text-xs font-semibold uppercase tracking-[0.18em] text-brand" data-id="element-49" data-mp="1kw2qre8rq8zj">
            Database reactivation
          </p>
          <h2 id="database-title" className="mt-5 font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-50" data-mp="1by0qx20rtmdu">
            The leads you already own.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-white/70 sm:text-lg" data-id="element-51" data-mp="120mc16uhx5nn">
            Most teams&rsquo; next closing is already sitting in their CRM. We re-engage
            your stale database with AI voice and text, surface the ones still in market,
            and book them onto your agents&rsquo; calendars.
          </p>
          <p className="mt-5 border-l-2 border-brand pl-5 font-display text-lg leading-relaxed text-white/85" data-id="element-52" data-mp="3jutobwy2w386">
            The 48% of leads that never got a second touch are not dead. They are just
            unworked.
          </p>
        </div>
      </div>
    </section>;
}